export function ellipsisFilter() {
	'ngInject';
	return (valueToModify, limit) => {
		if (!valueToModify) {
			return '';
		}

		if (valueToModify.length <= limit) {
			return valueToModify;
		}

		var sub = '...';
		var errPrefix = 'ellipsisFilter substitution error; ';
		if (sub.length > limit) {
			throw new Error(errPrefix + 'requested limit too short');
		}

		return valueToModify.substr(0, limit - sub.length) + sub;
	};
}
